package co.maytes.standupbot.dashboard.features.releases

import androidx.compose.runtime.Composable
import co.maytes.standupbot.dashboard.components.widgets.icons.LucideIcon
import co.maytes.standupbot.dashboard.components.widgets.icons.LucideTag

private const val MERGE_RADIUS = 3.0
private const val MERGE_FAR = 18.0
private const val MERGE_NEAR = 6.0

@Composable
fun MergedPullRequestIcon(size: Int = 16) =
    LucideIcon(
        size = size,
        paths = listOf("M6 21V9a9 9 0 0 0 9 9"),
        circles = listOf(Triple(MERGE_FAR, MERGE_FAR, MERGE_RADIUS), Triple(MERGE_NEAR, MERGE_NEAR, MERGE_RADIUS)),
    )

@Composable
fun ReleaseTagIcon(size: Int = 16) = LucideTag(size = size)

@Composable
fun ExternalLinkIcon(size: Int = 14) =
    LucideIcon(
        size = size,
        paths =
            listOf(
                "M15 3h6v6",
                "M10 14 21 3",
                "M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6",
            ),
    )

@Composable
fun FilterSlidersIcon(size: Int = 16) =
    LucideIcon(size = size, paths = listOf("M4 6h16", "M7 12h10", "M10 18h4"))

@Composable
fun ChevronRightIcon(size: Int = 16) = LucideIcon(size = size, paths = listOf("m9 18 6-6-6-6"))
